import React from 'react';
import { Button as MaterialButton } from '@material-ui/core';
import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => createStyles(
  {
    root: {
      height: '100%',
      [theme.breakpoints.down('lg')]: {
        '& svg': {
          maxHeight: 20,
          maxWidth: 20,
        },
      },
    },
    label: {
      textTransform: 'initial',
      fontWeight: 600,
      fontSize: 16,
      lineHeight: '24px',
      [theme.breakpoints.down('lg')]: {
        fontSize: 14,
        lineHeight: '21px',
      },
    },
    success: {
      background: '#00B400',
      borderRadius: 8,
      color: theme.palette.common.white,
      padding: 12,
      minWidth: 190,

      '&:hover': {
        color: '#00B400',
        background: theme.palette.common.white,
        border: `1px solid #00B400`,
      }
    },
    danger: {
      color: theme.palette.red.color,
      borderColor: theme.palette.red.color,

      '&:hover': {
        background: theme.palette.red.bg,
        borderColor: theme.palette.red.color,
      },
    },
    ai: {
      height: 'auto',
      background: `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
      color: theme.palette.common.white,
      borderRadius: 8,
      padding: '7px 12px 7px 10px',
      boxShadow: '0 2px 8px rgba(2, 44, 230, 0.25)',
      transition: 'transform 0.12s ease, box-shadow 0.15s ease',

      '& .MuiButton-label': {
        fontSize: 12,
        fontWeight: 500,
        lineHeight: 1.2,
        gap: 6,
      },
      '& svg': {
        width: '14px !important',
        height: '14px !important',
        flexShrink: 0,
      },
      '& svg path': {
        fill: theme.palette.common.white,
      },

      '&:hover': {
        background: `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
        transform: 'translateY(-1px)',
        boxShadow: '0 4px 12px rgba(2, 44, 230, 0.35)',
      },
      '&:active': {
        transform: 'translateY(0)',
      },
      '&.Mui-disabled, &.Mui-disabled:hover': {
        background: theme.palette.grey.color,
        color: theme.palette.common.white,
        boxShadow: 'none',
        transform: 'none',
      },
    },
  }
), {
  name: 'Button'
});

export const Button = ({ children, buttonType, className, ...rest }) => {
  const classes = useStyles();

  return (
    <MaterialButton
      {...rest}
      className={clsx(className, {
        [classes.success]: buttonType === 'success',
        [classes.ai]: buttonType === 'ai',
        [classes.danger]: buttonType === 'danger',
      })}
      classes={{
        root: classes.root,
        label: classes.label,
      }}
    >
      {children}
    </MaterialButton>
  );
}
